import {useEffect,useMemo,useState} from 'react';
import type {P01PaymentViewModel,SmtRuntimePort} from '../contracts.ts';

function parseTenderMinor(value:string):number|null{
  const normalized=value.trim();
  if(!/^\d+(?:\.\d{1,2})?$/.test(normalized))return null;
  const [whole,fraction='']=normalized.split('.');
  const minor=Number(whole)*100+Number(fraction.padEnd(2,'0'));
  return Number.isSafeInteger(minor)&&minor>0?minor:null;
}

export function PaymentOverlay({runtime,payment,onClose}:{runtime:SmtRuntimePort;payment:P01PaymentViewModel;onClose:()=>void}){
  const [methodId,setMethodId]=useState(payment.methods[0]?.methodId??'');
  const [tendered,setTendered]=useState('');
  const [reference,setReference]=useState('');
  const method=useMemo(()=>payment.methods.find(item=>item.methodId===methodId)??payment.methods[0],[payment.methods,methodId]);
  const tenderedMinor=method?.requiresTenderedAmount?parseTenderMinor(tendered):undefined;
  const canConfirm=Boolean(method&&(!method.requiresTenderedAmount||tenderedMinor!==null));

  useEffect(()=>{
    if(!payment.methods.some(item=>item.methodId===methodId))setMethodId(payment.methods[0]?.methodId??'');
  },[payment.methods,methodId]);

  if(!method)return <div className="payment-backdrop"><section className="payment-panel"><div className="payment-head"><div><small>收款</small><h2>未設定付款方式</h2></div><button className="payment-close" aria-label="關閉收款" onClick={onClose}>×</button></div><p>請由 SMT 啟動設定／管理端營運設定提供付款方式。</p></section></div>;

  const confirm=()=>{
    runtime.dispatch({
      type:'p01.payment.requested',
      methodId:method.methodId,
      ...(method.requiresTenderedAmount?{tenderedMinor:tenderedMinor??undefined}:{}),
      ...(method.referenceAllowed&&reference.trim()?{reference:reference.trim()}:{}),
    });
    onClose();
  };

  return <div className="payment-backdrop" role="presentation">
    <section className="payment-panel" role="dialog" aria-modal="true" aria-label="收款">
      <div className="payment-head"><div><small>尚欠金額</small><h2>{payment.outstandingLabel}</h2></div><div className="payment-head-actions"><span className="payment-authority-badge">系統核實</span><button className="payment-close" aria-label="關閉收款" onClick={onClose}>×</button></div></div>
      <div className="payment-methods" aria-label="付款方式">{payment.methods.map(item=><button key={item.methodId} aria-pressed={item.methodId===method.methodId} className={item.methodId===method.methodId?'selected':''} onClick={()=>{setMethodId(item.methodId);setTendered('');setReference('')}}>{item.label}</button>)}</div>
      {method.requiresTenderedAmount?<label className="payment-field"><span>實收現金</span><input inputMode="decimal" placeholder="例如 50" value={tendered} onChange={event=>setTendered(event.target.value)}/><small>找續由付款系統計算，畫面唔自行計。</small></label>:null}
      {method.referenceAllowed?<label className="payment-field"><span>付款參考（可選）</span><input value={reference} onChange={event=>setReference(event.target.value)} placeholder="FPS／交易參考"/></label>:null}
      <div className="payment-note">確認後只提交付款方式同店員輸入資料；應收／未收金額以系統最新資料為準。</div>
      <button className="payment-confirm" disabled={!canConfirm} onClick={confirm}>確認收款</button>
    </section>
  </div>;
}
